import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable()
export class AuthorizationService {
  constructor(private http: HttpClient) {}

  loadPermissions() {
    return this.http.get<string[]>(`${environment.api.nilo.user.root}/users/privileges`);
  }
}
